import React from "react";
import AuthFooter from "components/Footers/AuthFooter";
import API from '../api.js';
import { Toast, ToastBody, ToastHeader } from 'reactstrap';
// Import css files
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Card,
  CardBody,
  CardImg,
  CardText,
  CardTitle,
  Col,
  Row,
} from "reactstrap";
import AOS from "aos";
import "aos/dist/aos.css";
import data from '../data.js'
//images
import logo from "../assets/img/logo1.jpg";
import client1 from "../assets/img/new-clients/client1.jpeg";
import client2 from "../assets/img/new-clients/client2.jpeg";
import client3 from "../assets/img/new-clients/client3.jpeg";
import client4 from "../assets/img/new-clients/client4.png";
import client5 from "../assets/img/new-clients/client5.jpeg";
import client6 from "../assets/img/new-clients/client6.jpeg";
import client7 from "../assets/img/new-clients/client7.jpg";
import client8 from "../assets/img/new-clients/client8.jpeg";
import client9 from "../assets/img/new-clients/client9.jpeg";
import client10 from "../assets/img/new-clients/client10.jpeg";
import client11 from "../assets/img/new-clients/client11.jpeg";
import client12 from "../assets/img/new-clients/client12.jpeg";
import client13 from "../assets/img/new-clients/client13.jpeg";
import client14 from "../assets/img/new-clients/client14.jpeg";
import client15 from "../assets/img/new-clients/client15.jpeg";
import client16 from "../assets/img/new-clients/client16.jpeg";
import client17 from "../assets/img/new-clients/client17.png";
import client18 from "../assets/img/new-clients/client18.jpg";
// import client19 from "../assets/img/brand/client19.jpeg";
// import client20 from "../assets/img/brand/client20.jpeg";
// import client21 from "../assets/img/brand/client21.jpeg";
// import client22 from "../assets/img/brand/client22.jpeg";
// import client23 from "../assets/img/brand/client23.jpeg";
import society from "assets/img/brand/society.png";
import slider1 from "../assets/img/brand/slider4.jpg";
import slider2 from "../assets/img/brand/slider2.jpeg";
import slider3 from "../assets/img/brand/slider5.jpg";
// import about from "assets/img/brand/aboutus.jpeg";
import nedco from "assets/img/brand/nedco.png";
import gra from "assets/img/brand/gra.png";
import face4 from "assets/img/brand/face4.jpg";
import face1 from "assets/img/brand/face1.jpg";
import PTI35 from "assets/img/PTI35.jpg";
import PTS7 from "assets/img/PTS7.jpg";
import PTT from "assets/img/PTT.jpg";
import PTQ from "assets/img/PTQ.jpg";

//components
import Slider from "react-slick";
// import CalendarTable from "components/Tables/CalendarTable.js"

var clientSettings = {
  infinite: true,
  speed: 4000,
  slidesToShow: 3,
  slidesToScroll: 1,
  autoplay: true,
  dots: false,
  responsive: [
    {
      breakpoint: 450,
      settings: {
        centerMode: true,
        slidesToShow: 1,
      },
    },
  ],
};


function LandingPage(props) {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [color, setColor] = React.useState("white");
  const [collapseOpen, setCollapseOpen] = React.useState(false);

  const [name, setName] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [phone, setPhone] = React.useState("");
  const [subject, setSubject] = React.useState("");
  const [message, setMessage] = React.useState("");
  const [error, setError] = React.useState({})
  const [showAllClients, setShowAllClients] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);


async function handleFormSubmit(e) {
  e.preventDefault();
  setSubmitting(true);
  try {
    const response = await API.post('/send/enquiry/mail',{
      name, email, phone, subject, message
    });

    if(response && response.data){
    setEmail("");
    setName("");
    setPhone("");
    setSubject("");
    setMessage("");
    setError({
      color: 'success',
      title: 'Email Sent!',
      text: "Thank you, we will get back to you soon",
      showToast: true
    });

    setTimeout(() => {
      setError({})
    }, 5000)
    }
  } catch (error) {
  } finally {
    setSubmitting(false);
  }
}

  const newItems = [
    {
      id: 1,
      img: client1,
    },
    {
      id: 2,
      img: client2,
    },
    {
      id: 3,
      img: client3,
    },
    {
      id: 4,
      img: client4,
    },
    {
      id: 5,
      img: client5,
    },
    {
      id: 6,
      img: client6,
    },
    {
      id: 7,
      img: client7,
    },
    {
      id: 8,
      img: client8,
    },
    {
      id: 9,
      img: client9,
    },
    {
      id: 10,
      img: client10,
    },
    {
      id: 11,
      img: client11,
    },
    {
      id: 12,
      img: client12,
    },
    {
      id: 13,
      img: client13,
    },
    {
      id: 14,
      img: client14,
    },
    {
      id: 15,
      img: client15,
    },
    {
      id: 16,
      img: client16,
    },
    {
      id: 17,
      img: client17,
    },
    {
      id: 18,
      img: client18,
    },
    // {
    //   id: 19,
    //   img: client19,
    // },
    // {
    //   id: 20,
    //   img: client20,
    // },
    // {
    //   id: 21,
    //   img: client21,
    // },
    // {
    //   id: 22,
    //   img: client22,
    // },
    // {
    //   id: 23,
    //   img: client23,
    // },
  ];

  // const courses = [
  //   {
  //     id: 1,
  //     title: "Modules 1",
  //     aim: "To draw attention to essential leadership skills required of directors of MDAs in evolving a professional public sector organisation that delivers excellence to its stakeholders;",
  //     duration: "3",
  //   },
  //   {
  //     id: 2,
  //     title: "Modules 2",
  //     aim: "To emphasize the core skills and mindset required for succeeding as professionals and technocrats in an environment heavily dominated and influenced by politicians;",
  //     duration: "2",
  //   },
  //   {
  //     id: 3,
  //     title: "",
  //     aim: "",
  //     duration: "",
  //   },
  // ];

  const clients = [
    {
      id: 1,
      logo: gra,
      title: "Change Management Coordinator, Ghana Revenue Authority",
      text: "We’re very impressed with how GSR consulting provided quality and tailor-made training services on project management to some of our key staff who are engaged on different projects. Their ability to make the training very practical is commendable”.",
    },
    {
      id: 2,
      logo: nedco,
      title: "Performance Management and HR Services, NEDCo",
      text: "“GSR Consulting’s training has dismantled certain assumptions I had about people management. I recommend their services to managers at all levels and people who aspire to be in any management position”. ",
    },
    {
      id: 3,
      logo: society,
      title: " Head of Human Resource, Societe General Ghana",
      text: "“GSR Consulting has well-seasoned and expert resource persons who are able to relate theory to practice. The organization is always focused on delivering high-impact interventions that impact the bottom line. They are reliable” ",
    },
    {
      id: 4,
      logo: client12,
      title: "Health and Safety Unit, VRA – Accra",
      text: "“GSR Consulting facilitated a training Workplace Relations and Occupational Health for some of our Staff. This program has helped to establish stronger ties among our staff and improved the services we offer to our clients. Good work and well done GSR”. ",
    },
  ];
  const { bestCourses } = data;

  console.log('best c', bestCourses)

  React.useEffect(() => {
    AOS.init({
      duration: 2000,
    });


    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("info");
        setColor("black");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
        setColor("white");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  }, []);

  const handleAppClick = () => {
    if (collapseOpen === true) {
      document.documentElement.classList.toggle("nav-open");
      setCollapseOpen(false);
    }
  };

  return (
    <div>
    <div className={`p-3 bg-${error.color} my-2 rounded white`} style={{position:'fixed', right:20, zIndex:9999}}>
        <Toast isOpen={error.showToast}>
          <ToastHeader toggle={()=>setError({})}>
            {error.title}
          </ToastHeader>
          <ToastBody>
            {error.text}
          </ToastBody>
        </Toast>
      </div>
      <div id="app">
        {/*Home Start */}
        <h1 className="sr-only">Home section</h1>
        <Navbar className={"fixed-top " + navbarColor} expand="lg">
          <Container>
            <div className="navbar-translate">
              <NavbarBrand data-placement="bottom">
                <a href="/">
                  <div className="d-flex">
                    <img
                      alt="Course App"
                      src={logo}
                      style={{
                        height: "40px",
                        width: "auto",
                        borderRadius: "4px",
                        marginRight: "5px",
                      }}
                    />

                    <h3
                      className={color + " my-auto"}
                      style={{
                        fontWeight: 600,
                        textDecoration: "none",
                        textTransform: "capitalize",
                        fontSize: "22px",
                      }}
                    >
                      GSR TRAINING CONSULTING
                    </h3>
                  </div>
                </a>
              </NavbarBrand>
            </div>
            <div
              className="phone-view-hide"
              style={{ marginRight: "20px" }}
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(true);
              }}
              aria-expanded={collapseOpen}
            >
              <i className="fa fa-bars" style={{ color: "white" }} />
            </div>
            <Collapse
              className="justify-content-end"
              isOpen={collapseOpen}
              navbar
            >
              <Nav navbar>
                <NavItem className="active">
                  <NavLink href="#Home" className="scroll mr-3">
                    HOME
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink href="#about-us" className="scroll mr-3">
                    ABOUT
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink href="#services" className="scroll mr-3">
                    SERVICES
                  </NavLink>
                </NavItem>
                {/* <NavItem>
                  <NavLink href="#calendar" className="scroll mr-3">
                    CALENDAR
                  </NavLink>
                </NavItem> */}
                <NavItem>
                  <NavLink href="#service-3" className="scroll mr-3">
                    OUR CLIENTS
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink href="#contact-us" className="scroll mr-3">
                    CONTACT US
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="mt--2"
                    href="/overseas-training-calendar"
                    style={{
                      fontWeight: "700",
                      color: "yellow",
                      backgroundColor: "#17d0cf",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                  OVERSEAS TRAINING CALENDAR
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        <div onClick={() => handleAppClick()}>
          <section id="Home">
            {/*nav end*/}
            <div id="slider">
              {/* START REVOLUTION SLIDER 5.0 */}
              <div className="rev_slider_wrapper">
                <div id="slider1" className="rev_slider" data-version="5.0">
                  <ul>
                    <li
                      data-transition="slideup"
                      data-title="01"
                      data-delay="5000"
                      style={{
                        backgroundColor: "black",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {/* MAIN IMAGE */}
                      <img
                        src={slider1}
                        alt="cover"
                        style={{
                          width: "100%",
                          height: "100%",
                          opacity: "0.4",
                          objectFit: "cover",
                        }}
                      />
                      {/* LAYER NR. 1 */}
                      <h1
                        className="tp-caption News-Title text-center"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset=""
                        data-whitespace="normal"
                        data-transform_idle="o:1;"
                        data-transform_in="y:-50px;opacity:0;s:1500;e:Power3.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="1000"
                        data-fontsize="65"
                      >
                        Management
                      </h1>
                      <h1
                        className="tp-caption News-Title  text-center middleman"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset="70"
                        data-whitespace="normal"
                        data-transform_idle="o:1;"
                        data-transform_in="x:-50px;opacity:0;s:2000;e:Power3.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="1500"
                        data-width="670"
                        data-fontsize="65"
                      >
                        and <span>leadership</span>
                      </h1>
                      <p
                        className="tp-caption News-Title  text-center news-liner"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset="125"
                        data-whitespace="normal"
                        data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:1000;e:Power2.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="2200"
                        data-width="870"
                      >
                        Management and leadership development training and
                        consulting.
                      </p>
                    </li>
                    <li
                      data-transition="slideup"
                      data-title="02"
                      data-delay="5000"
                      style={{
                        backgroundColor: "black",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {/* MAIN IMAGE */}
                      <img
                        src={slider2}
                        alt="cover"
                        style={{
                          width: "100%",
                          height: "100%",
                          opacity: "0.4",
                          objectFit: "cover",
                        }}
                      />
                      {/* LAYER NR. 1 */}
                      <h1
                        className="tp-caption News-Title text-center"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset=""
                        data-whitespace="normal"
                        data-transform_idle="o:1;"
                        data-transform_in="y:-50px;opacity:0;s:1500;e:Power3.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="1000"
                        data-fontsize="65"
                      >
                        Management
                      </h1>
                      <h1
                        className="tp-caption News-Title  text-center middleman"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset="70"
                        data-whitespace="normal"
                        data-transform_idle="o:1;"
                        data-transform_in="x:-50px;opacity:0;s:2000;e:Power3.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="1500"
                        data-width="670"
                        data-fontsize="65"
                      >
                        and <span>leadership</span>
                      </h1>
                      <p
                        className="tp-caption News-Title  text-center news-liner"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset="125"
                        data-whitespace="normal"
                        data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:1000;e:Power2.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="2200"
                        data-width="870"
                      >
                        Management and leadership development training and
                        consulting.
                      </p>
                    </li>
                    <li
                      data-transition="slideup"
                      data-title="03"
                      data-delay="5000"
                      style={{
                        backgroundColor: "black",
                        width: "100%",
                        height: "100%",
                      }}
                    >
                      {/* MAIN IMAGE */}
                      <img
                        src={slider3}
                        alt="cover"
                        style={{
                          width: "100%",
                          height: "100%",
                          opacity: "0.4",
                          objectFit: "cover",
                        }}
                      />
                      {/* LAYER NR. 1 */}
                      <h1
                        className="tp-caption News-Title text-center"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset=""
                        data-whitespace="normal"
                        data-transform_idle="o:1;"
                        data-transform_in="y:-50px;opacity:0;s:1500;e:Power3.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="1000"
                        data-fontsize="60"
                      >
                        Management
                      </h1>
                      <h1
                        className="tp-caption News-Title  text-center middleman"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset="70"
                        data-whitespace="normal"
                        data-transform_idle="o:1;"
                        data-transform_in="x:-50px;opacity:0;s:2000;e:Power3.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="1500"
                        data-width="670"
                        data-fontsize="60"
                      >
                        {" "}
                        and <span>leadership</span>{" "}
                      </h1>
                      <p
                        className="tp-caption News-Title  text-center news-liner"
                        data-x="middle"
                        data-hoffset=""
                        data-y="middle"
                        data-voffset="125"
                        data-whitespace="normal"
                        data-transform_in="z:0;rX:0;rY:0;rZ:0;sX:0.9;sY:0.9;skX:0;skY:0;opacity:0;s:1000;e:Power2.easeOut;"
                        data-transform_out="s:1000;e:Power3.easeInOut;s:1000;e:Power3.easeInOut;"
                        data-start="2200"
                        data-width="870"
                      >
                        Management and leadership development training and
                        consulting.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              {/* END OF SLIDER WRAPPER */}
              {/* END REVOLUTION SLIDER */}
            </div>
          </section>
          <section id="about-us">
            <div id="about us-1" className="big-padding">
              <div className="container">
                <div className="row" style={{ alignItems: "stretch" }}>
                  <div className="col-md-6" style={{ display: "flex" }}>
                    <div className="left-section" style={{ width: "100%", position: "relative" }}>
                      <img
                        src={PTI35}
                        style={{ objectFit: "cover", width: "100%", height: "100%", display: "block" }}
                        alt="pineapple"
                        className="img-responsive"
                      />
                      <div
                        className="overlay"
                        style={{ width: "100%", height: "100%" }}
                      ></div>
                    </div>
                  </div>
                  <div className="col-sm-6">
                    <div className="right-section">
                      <h4 className="head-subtitle">About Us</h4>
                      <h2 className="big-text" style={{ marginLeft: "0px" }}>
                        We Are <strong>GSR Training</strong> Consulting
                      </h2>
                      <div className="section-divider"></div>
                      <p>
                        We’re excited you’re exploring our site. Our Company has been doing management and leadership
                        development training and consulting for more thana a decade! This should build confidence whether
                        you’re exploring our services for the first time, or have given us business in the past.
                      </p>

                      <h4><i className="fas fa-heart mr-2" style={{ color: "#17d0cf" }} />Our Passion</h4>
                      <p>
                        To see organizations become more efficient through the deployment of well-developed and
                        motivated employees, particularly top executives.
                      </p>
                      <h4><i className="fas fa-eye mr-2" style={{ color: "#17d0cf" }} />Our Vision</h4>
                      <p>
                        To be Africa’s leading provider of high-impact, leadership and management development and
                        consultancy services
                      </p>
                      <h4><i className="fas fa-bullseye mr-2" style={{ color: "#17d0cf" }} />Our Mission</h4>
                      <p>
                        Delivering affordable relevant management and leadership training and consultancy solutions,
                        employing modern adult learning tools and methods.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="services" style={{ marginTop: "-70px" }}>
            <div id="service-2" className="big-padding">
              <div className="container">
                <h4 className="head-subtitle">Our Services</h4>
                <h2 className="big-text" style={{ marginLeft: "0px" }}>
                  What We <strong>Do</strong>
                </h2>
                <div className="section-divider"></div>
                <p>
                  We deliver consultancy and training solutions that help managers to manage better, and guide
                  leaders to lead better and get better bottom-line results for their organizations. <br />
                </p>
                <p>
                <h5>We deliver trainging in two ways</h5>
                  <span className="list">
                    <ul>
                      <li>
                        <p>
                          Through in-house arrangements (designed together with clients and delivered within clients’ premises/preferred venue);
                        </p>
                      </li>
                      <li>
                        <p>
                          through our public training programs to which corporations send delegates.
                        </p>
                      </li>
                    </ul>
                  </span>
                </p>
                <div className="container">
                        <h2 className="big-text text-center mb-5"><strong>TRAININGS</strong></h2>
                  <div className="row">
                    <div className="col-md-6">
                      <img
                        src={PTS7}
                        width={542}
                        alt="pineapple"
                        className="element-center"
                        style={{ objectFit: "cover", height: "100%" }}
                      />
                    </div>
                    <div className="col-md-6">
                      <div>
                        <h3>Our Training Philosophy & Pedagogy</h3>
                        <p>
                          We operate a philosophy of training built on a
                          methodology that incorporates a variety of relevant
                          practical, reflective sessions involving exercises and
                          activities. <br />
                          This means that training sessions are necessarily
                          followed by a list of:
                        </p>
                        <p>
                          a) <strong>Key Ideas</strong> that can be applied to
                          the work situation;
                        </p>
                        <p>
                          b) <strong>Learning & Growth Points</strong> outlining
                          the{" "}
                          <strong>
                            habits, attitudes and behaviours (HABs)
                          </strong>{" "}
                          that delegates would need to{" "}
                          <strong>stop, start or strengthen (3S)</strong> in
                          order to activate and implement the necessary changes
                          arising from the knowledge gained from the training:
                        </p>
                        <p>
                          c) <strong>A Personal Action Plan</strong> – which
                          outlines:
                          <span className="list">
                            <ul>
                              <li>
                                <p>The Major Actions to be taken;</p>
                              </li>
                              <li>
                                <p>
                                  Resources required for taking such actions;
                                </p>
                              </li>
                              <li>
                                <p>
                                  Specific help/assistance required from any
                                  person or entity;
                                </p>
                              </li>
                              <li>
                                <p>Timelines for accomplishing such action.</p>
                              </li>
                            </ul>
                          </span>
                        </p>
                        <a
                          style={{ color: "white", backgroundColor: "#17d0cf" }}
                          role="button"
                          href="/training-offerings"
                          className="btn button"
                        >
                          See All Training offerings
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container mid-level-padding">
                        <h2 className="big-text text-center mb-5"><strong>CONSULTANCY</strong></h2>
                    <div className="row gx-5">
                        <div className="col-md-6">
                        <div>
                            <h3>We have three consultancy products that have been designed exclusively for public sector organisation, and
                              two others for private sectors organisation, but which public sector organisations would also find useful.
                            </h3>
                            <br/>
                            <h3>Public Sector</h3>
                            <div className="list">
                              <ul>
                                <li><p>Exclusively Public Sector Chief Executives (EPSCE)<br/>
                                  (Support Public Sector Leaders to Achieve Extraordinary Results)
                                </p></li>
                                <li><p>Public Sector Support International (Retooling Government for Results) 
                                  Cost-Saving Strategies for Government and Public Sectors.
                                  </p></li>
                                <li><p>Public Service Excellence Program</p></li>
                              </ul>
                            </div>
                            
                           <h3>Private Sectors</h3>

                           <div className="list">
                              <ul>
                                <li><p>HR Transformations</p></li>
                                <li><p>HR Outsourcing Modules</p></li>
                              </ul>
                            </div>

                            <a
                              style={{ color: "white", backgroundColor: "#17d0cf" }}
                              role="button"
                              href="/consultancy"
                              className="btn button mt-2"
                            >
                              See All Consultancy Offerings
                            </a>
                          </div>
                        </div>
                        <div className="col-md-6 d">
                        <img
                            src={face1}
                            width={542}
                            style={{objectFit:"cover", height:"100%"}}
                            alt="pineapple"
                            className="element-center"
                          />
                        </div>
                    </div>
                </div>  
              </div>
            </div>
            {/* service-2 end */}
          </section>

          {/* <section id="calendar" className=" pt-8">
            <div className="container">
            <h4 className="head-subtitle">GSR Consulting</h4>
                  <h2
                    className="big-text"
                    style={{ marginLeft: 0, color: "black" }}
                  >
                    <strong>2022 </strong>Training Calendar
                  </h2>
                  <hr />
                  <div className="row wow fadeInUp" data-wow-duration="2s">
                    <div className="col-sm-12">
                      <div className="bottom-section text-center" style={{ overflow:"auto" }}>
                        <CalendarTable />
                      </div>
                    </div>
                  </div>
            </div>
          </section> */}

            <section id="service-3" className="pt-8 pb-5">
                <div className="container">
                  <h4 className="head-subtitle">Our Clients</h4>
                  <h2
                    className="big-text"
                    style={{ marginLeft: 0, color: "black" }}
                  >
                    <strong>Excellent</strong> Services
                  </h2>
                  <div className="section-divider"></div>
                  <div className="clients-grid mt-4">
                    {(showAllClients ? newItems : newItems.slice(0, 10)).map((value) => (
                      <div key={value.id} className="client-card">
                        <img src={value.img} alt={`Client ${value.id}`} loading="lazy" />
                      </div>
                    ))}
                  </div>
                  <div className="text-center mt-5">
                    {!showAllClients && (
                      <button
                        onClick={() => setShowAllClients(true)}
                        style={{
                          color: "white",
                          backgroundColor: "#17d0cf",
                          border: "none",
                          borderRadius: "50px",
                          padding: "12px 36px",
                          fontWeight: 600,
                          fontSize: "15px",
                          cursor: "pointer",
                        }}
                      >
                        Show More
                      </button>
                    )}
                  </div>
                </div>
              </section>


          {/*  services end*/}
          <section id="portfolio">
            <div id="portfolio3" className="mid-level-padding mt-8" style={{backgroundColor:'#f5f5f5'}}>
              <div className="container">
                {/* <div className="row">
                    <div className="col-xs-12">
                      <div className="section-top-heading">
                        <h4 className="head-subtitle">Search our courses</h4>
                        <h2 className="big-text" style={{marginLeft:0}}>Browse Our <strong>Best Courses</strong></h2>
                        <hr/>
                      </div>
                    </div>
                  </div> */}
                <h4 className="head-subtitle">Search our courses</h4>
                <h2 className="big-text" style={{ marginLeft: "0px" }}>
                  Browse Our <strong>Best Courses</strong>
                </h2>
                <div className="section-divider"></div>
                <Row>
                  {bestCourses.map((value) => (
                    <Col md="4" key={value.id}>
                      <Card className="main_card">
                        <div className="cover">
                          <CardImg
                            top
                            width="100%"
                            src={`./img/${value.image}`}
                            alt="Card image cap"
                            className="card_image"
                            style={{ position: "relative" }}
                          />

                          <a
                            style={{
                              borderRadius: "10px",
                              color: "white",
                              backgroundColor: "#17d0cf",
                            }}
                            role="button"
                            className="next btn button"
                            href={`/course/${value.title}/${value.id}/training/details`}
                          >
                            View details <i className="fa fa-chevron-right"></i>
                          </a>
                        </div>
                        <CardBody>
                          <CardTitle tag="h5">{value.title}</CardTitle>
                          {/* <CardText>
                            This is a wider card with supporting text below as a
                            natural lead-in to additional content. This content
                            is a little bit longer.
                          </CardText> */}
                          <CardText>
                            <small className="text-muted">
                              Modules ({value.modules && value.modules.length})
                            </small>
                          </CardText>
                        </CardBody>
                      </Card>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>

            <div id="portfolio3" className="mid-level-padding">
              <div className="container">
                <h4 className="head-subtitle">our clients</h4>
                <h2 className="big-text" style={{ marginLeft: "0px" }}>
                  What Our <strong>Clients</strong> Say About Us
                </h2>
                <div className="section-divider"></div>
                <Row>
                  <Col md="12" className="mr-auto ml-auto">
                    <Slider {...clientSettings} infinite={clients.length > 3}>
                      {clients.map((value) => (
                        <Col key={value.id} style={{ padding: "8px 12px" }}>
                          <div style={{
                            background: "white",
                            borderRadius: "16px",
                            padding: "32px 28px 24px",
                            boxShadow: "0 4px 24px rgba(0,0,0,0.07)",
                            border: "1px solid #f0f2f4",
                            display: "flex",
                            flexDirection: "column",
                            height: "100%",
                          }}>
                            <p style={{ fontSize: "13px", lineHeight: "1.85", color: "#555", flex: 1, fontStyle: "italic", marginBottom: "24px" }}>
                              {value.text.trim().replace(/^["\u201C\u201D]+/, '').replace(/["\u201C\u201D][.\s]*$/, '').trim()}
                            </p>
                            <div style={{ display: "flex", alignItems: "center", gap: "14px", borderTop: "1px solid #f0f2f4", paddingTop: "20px" }}>
                              <img
                                alt={value.title}
                                src={value.logo}
                                style={{ borderRadius: "50%", width: "48px", height: "48px", objectFit: "cover", border: "2px solid #17d0cf", flexShrink: 0 }}
                              />
                              <div style={{ fontWeight: 700, fontSize: "12px", color: "#333", lineHeight: "1.5" }}>
                                {value.title}
                              </div>
                            </div>
                          </div>
                        </Col>
                      ))}
                    </Slider>
                  </Col>
                </Row>
              </div>
            </div>

            {/* contact-us */}
            <div id="contact-us" className="contact-section">
              <Container>
                <div className="text-center mb-5">
                  <h4 className="head-subtitle">Contact</h4>
                  <h2 className="big-text" style={{ marginLeft: 0 }}>
                    Get in <strong>Touch</strong>
                  </h2>
                </div>
                <div className="contact-card">
                  <Row style={{ margin: 0 }}>
                    {/* Info Panel */}
                    <Col md="5" className="contact-info-panel">
                      <p style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "2px", opacity: 0.8, marginBottom: "8px" }}>
                        Reach Us
                      </p>
                      <h2 style={{ fontSize: "34px", fontWeight: 700, fontFamily: "Raleway, sans-serif", marginBottom: "12px" }}>
                        Let's Talk
                      </h2>
                      <p style={{ opacity: 0.85, marginBottom: "40px", fontSize: "15px" }}>
                        What issues do you have? We are here to help you.
                      </p>

                      <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "28px", gap: "16px" }}>
                        <div className="contact-info-icon">
                          <i className="fa fa-phone" />
                        </div>
                        <div>
                          <div style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7, marginBottom: "4px" }}>Phone</div>
                          <div style={{ fontWeight: 600, fontSize: "15px" }}>+233 30 396 8042</div>
                        </div>
                      </div>

                      <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "28px", gap: "16px" }}>
                        <div className="contact-info-icon">
                          <i className="fa fa-envelope" />
                        </div>
                        <div>
                          <div style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7, marginBottom: "4px" }}>Email</div>
                          <a href="mailto:info@resourcegsr.com" style={{ fontWeight: 600, fontSize: "15px", color: "white", textDecoration: "none" }}>
                            info@resourcegsr.com
                          </a>
                        </div>
                      </div>

                      <div style={{ display: "flex", alignItems: "flex-start", marginBottom: "44px", gap: "16px" }}>
                        <div className="contact-info-icon">
                          <i className="fa fa-map-marker" />
                        </div>
                        <div>
                          <div style={{ fontSize: "11px", textTransform: "uppercase", letterSpacing: "1px", opacity: 0.7, marginBottom: "4px" }}>Location</div>
                          <div style={{ fontWeight: 600, fontSize: "15px" }}>Accra, Ghana</div>
                        </div>
                      </div>

                      <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                        <a href="https://www.facebook.com/share/1F3XLGwakr/?mibextid=qi2Omg" target="_blank" rel="noopener noreferrer" className="contact-social-link">
                          <i className="fab fa-facebook-f" />
                        </a>
                        <a href="https://www.instagram.com/gsrtrainingconsulting?igsh=bHU2bDJzOTZuaTY1" target="_blank" rel="noopener noreferrer" className="contact-social-link">
                          <i className="fab fa-instagram" />
                        </a>
                        <a href="https://www.linkedin.com/in/gsr-consulting-325230248" target="_blank" rel="noopener noreferrer" className="contact-social-link">
                          <i className="fab fa-linkedin-in" />
                        </a>
                        <a href="https://www.youtube.com/c/SamuelTengey" target="_blank" rel="noopener noreferrer" className="contact-social-link">
                          <i className="fab fa-youtube" />
                        </a>
                      </div>
                    </Col>

                    {/* Form Panel */}
                    <Col md="7" className="contact-form-panel">
                      <form onSubmit={handleFormSubmit}>
                        <Row>
                          <Col sm="6">
                            <input
                              type="text"
                              className="contact-input"
                              placeholder="Your Name"
                              required
                              name="name"
                              value={name}
                              onChange={(e) => setName(e.target.value)}
                            />
                          </Col>
                          <Col sm="6">
                            <input
                              type="email"
                              className="contact-input"
                              placeholder="Email Address"
                              required
                              name="email"
                              value={email}
                              onChange={(e) => setEmail(e.target.value)}
                            />
                          </Col>
                          <Col sm="6">
                            <input
                              type="text"
                              className="contact-input"
                              placeholder="Phone No."
                              required
                              name="phone"
                              value={phone}
                              onChange={(e) => setPhone(e.target.value)}
                            />
                          </Col>
                          <Col sm="6">
                            <input
                              type="text"
                              className="contact-input"
                              placeholder="Subject"
                              required
                              name="subject"
                              value={subject}
                              onChange={(e) => setSubject(e.target.value)}
                            />
                          </Col>
                          <Col sm="12">
                            <textarea
                              className="contact-input"
                              placeholder="Your Message"
                              required
                              name="message"
                              value={message}
                              onChange={(e) => setMessage(e.target.value)}
                            />
                          </Col>
                        </Row>
                        <button type="submit" className="contact-submit-btn" disabled={submitting} style={{ opacity: submitting ? 0.75 : 1 }}>
                          {submitting ? (
                            <>
                              <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" style={{ width: "16px", height: "16px", borderWidth: "2px" }} />
                              Sending...
                            </>
                          ) : (
                            <>Send Message <i className="fa fa-paper-plane" /></>
                          )}
                        </button>
                      </form>
                    </Col>
                  </Row>
                </div>
              </Container>
            </div>
          </section>
          <div class="loader">
            <div id="cssload-pgloading">
              <div class="cssload-loadingwrap">
                <ul class="cssload-bokeh">
                  <li></li>
                  <li></li>
                  <li></li>
                  <li></li>
                </ul>
              </div>
            </div>

            <div class="cssload-loadingwrap">
              <ul class="cssload-bokeh">
                <li></li>
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
